export default "__VITE_ASSET__DyTDNtIh__"